import { Dropzone } from '@mantine/dropzone';
import { Text } from '@mantine/core';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);
const PlainDropzone = asPlainComponent<ComponentProps<typeof Dropzone>>(Dropzone);

export const ProgressBarContainer = styled.div`
	display: flex;
	margin-top: 2rem;
	gap: 0.5rem;
	justify-content: center;
	align-items: center;
`;

export const FullWidth = styled.div`
	width: 100%;
`;

export const InnerBox = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;
	height: 100%;
	width: 100%;
	justify-content: center;
`;

export const FooterText = styled.div`
	color: #0e171c;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.25rem;
`;

export const FooterWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 2rem;
	align-self: stretch;
`;

export const StyledTextButton = styled(PlainText)`
	color: #0d5ef2;
	font-variant-numeric: lining-nums tabular-nums;
	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.25rem;
	cursor: pointer;
`;

export const StyledSubText = styled(PlainText)`
	color: #4f616c;
	font-variant-numeric: lining-nums tabular-nums;
	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
`;

export const DashedBox = styled.div<{ $minWidth?: string; $height?: string }>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	border: 1px dashed #bdc4c8;
	border-radius: 0.5rem;
	padding: 1rem;
	cursor: pointer;
	height: ${({ $height }) => $height ?? '11.75rem'};

	min-width: ${({ $minWidth }) => $minWidth ?? '18rem'};
	&:hover {
		background-color: ${({ theme }) => theme.v2.color.secondary[200]};
	}

	button {
		margin-left: unset;
	}
`;

export const StyledDropzone = styled(PlainDropzone)<{ $width?: string }>`
	padding: 0;
	border: none;
	cursor: auto;

	&:hover {
		background-color: transparent;
	}

	.mantine-Dropzone-inner {
		pointer-events: all;
		width: ${({ $width }) => $width ?? null};
	}
`;
